// Ограничения зеркалят проверки бэка (TablesWarehouseService) — форма не даёт уйти в отказ.
export const MIN_TABLE_NUMBER = 1;
export const MAX_TABLE_NUMBER = 999;
export const MAX_TABLES_PER_BATCH = 200;
